"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../constants/index.js");
var getDefaultSetup = function getDefaultSetup() {
  return {
    adobeLaunch: undefined,
    brand: _index.brandValues.types.TELUS
  };
};
var _default = exports["default"] = getDefaultSetup;